import React, {Component, Fragment} from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

import InternalCalendar from './InternalCalendar'
import Restrictions from './Restrictions'

export default class Appointments extends Component {
    componentDidMount(){
        
    }
    render(){
        return (
            <Switch>
                <Route exact path='/:key/admin/appointments/restrictions' component={Restrictions} />
                <Route exact path='/:key/admin/appointments/:calendar' component={InternalCalendar} />
            </Switch>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/templates/Appointments/index.js